import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class AppConfigService {
  private config: any;

  constructor(private http: HttpClient) {}

  loadAppConfig(): Promise<void> {
    return this.http
      .get("/config/config.json")
      .toPromise()
      .then((config) => {
        this.config = this.normalizeConfig(config);
      })
      .catch(() => {
        const origin = window.location.origin;
        this.config = {
          ip: origin,
          port: "",
          context: "/amm-web-backend",
          baseUrl: `${origin}/amm-web-backend`,
        };
      });
  }

  private normalizeConfig(config: any): any {
    if (!config) {
      return config;
    }

    if (!config.baseUrl && config.apiUrl) {
      config.baseUrl = String(config.apiUrl).replace(/\/$/, "");
    }

    if (!config.baseUrl && config.ip && config.context !== undefined) {
      const portPart = config.port ? `:${config.port}` : "";
      config.baseUrl = `${config.ip}${portPart}${config.context}`;
    }

    const isRunningOnLocalhost =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1";

    if (
      config.baseUrl &&
      String(config.baseUrl).includes("localhost") &&
      !isRunningOnLocalhost
    ) {
      config.baseUrl = `${window.location.origin}/amm-web-backend`;
    }

    return config;
  }

  get Config() {
    return this.config;
  }

  getConfig() {
    return this.config;
  }

  get host(): string {
    return `${this.config.ip}:${this.config.port}${this.config.context}`;
  }
}
